import { useState } from "react";
import { IconButton, Popover, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Reusable (i) info button. Shows the field help copy in a click-open Popover
 * (with a hover Tooltip for quick peeks). Presentation-only — no functional
 * wiring. Copy strings live in ./fieldInfoContent.js so admin + preview share
 * one source of truth.
 *
 *   <FieldInfo text={FIELD_INFO['plan.name']} />
 */
export default function FieldInfo({ text, size = "small", label }) {
  const [anchorEl, setAnchorEl] = useState(null);
  if (!text) return null;
  const open = Boolean(anchorEl);
  return (
    <>
      <Tooltip title={text} arrow enterDelay={400}>
        <IconButton
          type="button"
          size={size}
          aria-label={label || "More info"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          }}
          sx={{
            p: "2px",
            ml: 0.25,
            color: "#8a94a6",
            "&:hover": { color: "#4f46e5" },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={(e) => {
          if (e?.stopPropagation) e.stopPropagation();
          setAnchorEl(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{ zIndex: 4000 }}
        PaperProps={{
          sx: {
            maxWidth: 300,
            p: 1.25,
            borderRadius: "10px",
            boxShadow: "0 8px 28px rgba(0,0,0,0.16)",
          },
        }}
      >
        <Typography sx={{ fontSize: 13, lineHeight: 1.5, color: "#374151" }}>
          {text}
        </Typography>
      </Popover>
    </>
  );
}
